import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Warehouses } from "app/_models/warehouses";
import { CrudWarehouseService } from "app/_services/MasterCrudOps/crud-warehouse.service";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { AddWarehouseComponent } from "./add-warehouse/add-warehouse.component";
import { EditWarehouseComponent } from "./edit-warehouse/edit-warehouse.component";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
declare const swal: any;

@Component({
  selector: "app-warehouse",
  templateUrl: "./warehouse.component.html"
})
export class WarehouseComponent implements OnInit, AfterViewInit {
  Warehouses: Warehouses[];
  totalresultDetails: Warehouses[];
  displayedColumns: string[] = [
    "icon",
    "warehouseName",
    "description",
    "stateName",
    "cityName",
    "address",
    "warehouseManager",
    "edit",
    "delete",
  ];
  dataSource = new MatTableDataSource<Warehouses>([]);
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  editHouse: Warehouses;
  pageEvent: PageEvent;


  constructor(
    public datepipe: DatePipe,
    private readonly crudWarehouseService: CrudWarehouseService,
    private readonly _liveAnnouncer: LiveAnnouncer,
    private readonly matDialog: MatDialog,
   
  ) {}


  
  ngOnInit(): void {
    this.isLoaderResult = true;
    this.dataSource = null; 
    this.Warehouses = null;
    this.pageSize  = 25;
    this.getWarehouses(1, this.pageSize, false);
    this.isLoaderResult = false;
  }

  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  getWarehouses(pageNumber: number, currPageSize: number, hasDownloadAllData:boolean) {
    let model = {
      currentPage: pageNumber,
      pageSize: currPageSize,
      downloadAllData: hasDownloadAllData,
      stateId:0
    } ;
    this.crudWarehouseService
    .getPagedActiveWareHouses(model)
    .subscribe((data) => {
      this.isLoaderResult = false;
      if (!data.didError) {
        this.Warehouses = data.model;
        this.dataSource = new MatTableDataSource<Warehouses>(
          this.Warehouses
        );
        this.totalRows = data.totalRecords;
        this.resultLength = this.Warehouses.length;
      } else {
        this.Warehouses = data.model;
        swal({
          title: "",
          text: data.message,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    },
    (error) => {
      this.isLoaderResult = false;
      swal({
        title: "",
        text: "Somthing went wrong. Please contact admin",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    }
  );
}



  openDialog() {
    const dialogRef = this.matDialog.open(AddWarehouseComponent, {
      width: "1000px",
      disableClose: false,
      data: {pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status )
      {
        this.getWarehouses(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }
  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  updateHouse(e:any, element:any): void {
    this.editHouse = JSON.parse(JSON.stringify(element));
    const dialogRef = this.matDialog.open(EditWarehouseComponent, {
      width: "800px",
      disableClose: true,
      data: {  warehouse:this.editHouse,   pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getWarehouses(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }
  onSubmit() {
    this.ngOnInit();
  }

  softdelete(e, element) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteHouse(e, element);
      }
    });
  }

  deleteHouse(e, element): void {
    this.crudWarehouseService
      .deleteWarehouse(element.warehouseId)
      .subscribe((data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message + "\n" + data.additionalMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.ngOnInit();
        }
      });
  }

   
    downloadAllRecords()
    {
      swal({
        title: "Are you sure to do this?",
        text: "This process does not display data. It will download all records in a spreadsheet.",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "YES, Download the records.",
      }).then((result) => {
        if (result === true) {
          this.isLoaderResult = true;
          let model = {
            currentPage:0,
            pageSize:0,
            downloadAllData:true,
            stateId: 0
          };
         this.crudWarehouseService
              .getPagedActiveWareHouses(model)
             .subscribe(
                      (results) => {
            this.isLoaderResult = false;
            if (!results.didError) {
              this.totalresultDetails = results.model;
              const workSheet = XLSX.utils.json_to_sheet(
                this.totalresultDetails.map((item) => {
                  return {
                    Name: item.warehouseName,
                    Description: item.description,
                    State: item.stateName,
                    City: item.cityName,
                    Address: item.address,
                    Manager: item.warehouseManager,
                  };
                })
              );
              const workBook: XLSX.WorkBook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
              let fileName =
              "Datacenter_" +
              this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
              ".xlsx";
              XLSX.writeFile(workBook, fileName);
            } else {
              this.isLoaderResult = false;
              swal({
                title: "",
                text: results.message,
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
            }
          },
          (error) => {
            this.isLoaderResult = false;
            swal({
              title: "",
              text: "Somthing went wrong. Please contact admin",
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        );
        }
      });
    }

  applyFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getWarehouses((this.paginator.pageIndex+1), this.paginator.pageSize, false);
  }
}
